import loadable from '@loadable/component';
import Loading from '../../components/Loader';

const UploadPage = loadable(
  () => import(/* webpackChunkName: "doe-upload-page" */ '../../pages/Doe/upload/UploadPage'),
  {
    fallback: Loading,
  }
);

export default UploadPage;
